export default {
  save: (key, tableId, value) => {
    localStorage.setItem(`${window.location.pathname}-${tableId}-${key}`, value);
  },
  get: (key, tableId) => localStorage.getItem(`${window.location.pathname}-${tableId}-${key}`),
};
